import error404PageConfig from '@ameroservices-platform/loppe-flexposui/app/main/apps/error/404/error404PageConfig';
import error500PageConfig from '@ameroservices-platform/loppe-flexposui/app/main/apps/error/500/error500PageConfig';
import flexposConfig from '@ameroservices-platform/loppe-flexposui/app/main/apps/FlexposConfig';

const appsConfigs = [error404PageConfig, error500PageConfig, flexposConfig];

export default appsConfigs;
